import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import LoadingComponent from '../loadingComponent';
import { AddIcon2, ClassetEditIcon } from '../svgIcons';
import { Button } from 'primereact/button';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'; // Corrected import for Column
import { BasicLazyParams } from '../../utile';
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
import './style.scss';
import Service from '../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import { InputSwitch } from 'primereact/inputswitch';
import CreateOrg from './createOrganization/index';
import { Tooltip } from 'primereact/tooltip';
import OrgConfiguration from '../orgnizationMaster/orgConfiguration';
import { Menu } from 'primereact/menu';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';

const organizationItems = [
    { key: 'o1', label: 'Organization' },
    { key: 'o2', label: 'Organization Master', className: 'ma-active-item', url: '/organization' }
];

const editConfigItems = [
    { key: 'co1', label: 'Organization' },
    { key: 'co2', label: 'Organization Master' },
    { key: 'co3', label: 'Configurations', className: 'ma-active-item' }
];

class OrganizationSetupIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lazyParams: BasicLazyParams,
            globalSearch: '',
            isCreateOrEdit: false,
            organizations: [],
            totalRecords: 0,
            isLoading: false,
            editOrganization: null,
            // Add this to track current page and rows
            first: 0,
            rows: BasicLazyParams.rows || 10,
            columns: [
                // { columnName: 'User App', isVisible: false, id: 'userApp' },
                // { columnName: 'Admin App', isVisible: false, id: 'adminApp' },
                { columnName: 'Org Code', isVisible: false, id: 'orgCode' },
                { columnName: 'Org Id', isVisible: false, id: '_id' }
            ]
        };
        this.service = new Service();
    }

    onColumnClick = (column) => {
        let columns = this.state.columns.map(c => {
            if (column.id == c.id) {
                c.isVisible = !c.isVisible;
            }
            return c;
        });
        this.setState({
            columns
        });
    }


    isColumnVisible = (id) => {
        return this.state.columns.filter(c => c.id == id)[0].isVisible;
    }

    componentDidMount() {
        this.getOrganizations();
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.isCreateOrEdit !== this.state.isCreateOrEdit ||
            prevState.lazyParams.page !== this.state.lazyParams.page ||
            prevState.lazyParams.rows !== this.state.lazyParams.rows
        ) {
            this.getOrganizations();
        }
    }

    onPage = (event) => {
        // Update lazyParams and pagination state
        const newLazyParams = {
            ...this.state.lazyParams,
            page: event.page,
            rows: event.rows,
        };
        this.setState({
            lazyParams: newLazyParams,
            first: event.first,
            rows: event.rows,
        });
    };

    onEditConfigClick = (orgData) => {
        this.setState({
            editOrganization: orgData,
            isShowConfigChange: true,
            items: editConfigItems
        });
    };

    getOrganizations = () => {
        this.setState({
            isLoading: true,
            organizations: [],
            totalRecords: 0
        });

        const { lazyParams, globalSearch } = this.state;

        const url = `${baseUrlAdmin}/organization/getall?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}${lazyParams.sortField ? `&sort=${lazyParams.sortOrder === 1 ? '' : '-'}${lazyParams.sortField}` : ''}`;

        this.service
            .post(url, lazyParams.filters, true)
            .then((res) => {
                if (res && res.status && res.res.success) {
                    // Ensure isActive field exists, default to true if undefined
                    const organizations = res.res.data.organizations.map(org => ({
                        ...org,
                        isActive: org.isActive !== undefined ? org.isActive : true
                    }));
                    
                    this.setState({
                        organizations: organizations,
                        totalRecords: res.res.data.totalRecords,
                        isLoading: false
                    });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                console.log(e);
            });
    };

    onStatusChange = (e, rowData) => {
        this.setState({ isLoading: true });
        
        const url = `${baseUrlAdmin}/organization/changestatus`;
        const data = {
            orgId: rowData._id,
            isActive: e.value
        };
        
        this.service
            .post(url, data, true)
            .then((res) => {
                if (res && res.status && res.res.success) {
                    let organizations = this.state.organizations.map((i) => {
                        if (i._id == rowData._id) {
                            i.isActive = e.value;
                        }
                        return i;
                    });
                    this.setState({
                        organizations,
                        isLoading: false
                    });
                    this.toast.show({ 
                        severity: 'success', 
                        summary: 'Success', 
                        detail: `Organization ${e.value ? 'activated' : 'deactivated'} successfully`, 
                        life: 3000 
                    });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: res.errMessage || 'Failed to update organization status', 
                        life: 3000 
                    });
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                console.log(e);
                this.toast.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'Failed to update organization status', 
                    life: 3000 
                });
            });
    };

    onEdit = (rowData) => {
        this.setState({ editOrganization: rowData, isCreateOrEdit: true });
    };
    setCreateOrEdit = () => {
        this.setState({ editOrganization: null, isCreateOrEdit: !this.state.isCreateOrEdit });
    };
    render() {
        const { isCreateOrEdit, organizations, isLoading, first, rows, totalRecords } = this.state;

        return (
            <>
                {isCreateOrEdit ? (
                    <CreateOrg editOrganization={this.state.editOrganization} setCreateOrEdit={this.setCreateOrEdit} />
                ) : (
                    <div className="admin-management">
                        <div className="grid mb-6 mt-2">
                            <div className="col-12 flex justify-content-end align-items-center">
                                <Button className="addButtonn" onClick={this.setCreateOrEdit}>
                                    <AddIcon2 />
                                    <p className="">Add Organization</p>
                                </Button>
                            </div>
                        </div>

                        <div className="flex justify-content-between align-items-center ma-m30 mb-2">
                            {/* view */}
                            <div className="flex">
                                <h4>Organization List</h4>
                                {this.state.showSearch && <InputText placeholder="Search" value={this.props.globalSearch} className="ml-4  h-2rem w-15rem" onChange={this.props.onGlobalSearch} />}
                            </div>
                            <div className="bg-blue-50 cursor-pointer mb-2 border-round">
                                <ul className="flex gap-5 mr-6">
                                    {/* <Authorizer permId={PERMISSIONS.ORG_SEARCH}> */}
                                    {/* <i data-pr-tooltip="Search" data-pr-position="bottom" className="pi pi-search ma-tbl-icon ma-tbl-srch" onClick={(e) => { this.setState({ showSearch: !this.state.showSearch }) }}></i>
                                    <Tooltip className="table-li-tooltip" autoHide={false} target=".ma-tbl-srch" /> */}
                                    {/* </Authorizer> */}
                                    {/* <li><i data-pr-tooltip="Filter" data-pr-position="bottom" className="pi pi-filter ma-tbl-icon ma-tbl-fi"></i></li>
                                                    <Tooltip className="table-li-tooltip" target=".ma-tbl-fi" /> */}
                                    {/* <Authorizer permId={PERMISSIONS.ORG_VIEW_COLUMNS} > */}
                                    <i onClick={(event) => this.menu.toggle(event)} data-pr-tooltip="View Columns" data-pr-position="bottom" className="pi pi-sort-alt ma-tbl-icon ma-tbl-sort"></i>
                                    <Tooltip className="table-li-tooltip" target=".ma-tbl-sort" />
                                    {/* </Authorizer> */}
                                    {/* <Authorizer permId={PERMISSIONS.ORG_DOWNLOAD} > */}
                                    {/* <i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download ma-tbl-icon ma-tbl-dwnld" onClick={this.exportCSV}></i>
                                    <Tooltip className="table-li-tooltip" target=".ma-tbl-dwnld" /> */}
                                    {/* </Authorizer> */}
                                </ul>
                            </div>
                            <Menu
                                model={[
                                    {
                                        template: (<div className='ml-2 p-2'>
                                            <h4>View Columns</h4>
                                            <ul>
                                                {this.state.columns.map((column) => {
                                                    return <li onClick={() => this.onColumnClick(column)}><Checkbox inputId={column.id}
                                                        checked={column.isVisible} className='mt-2'
                                                    ></Checkbox>
                                                        <label htmlFor={column.id} className="ml-2">{column.columnName}</label>
                                                    </li>
                                                })}
                                            </ul>
                                        </div>)
                                    }]
                                }
                                popup
                                ref={el => this.menu = el} />
                        </div>
                        <div className="ma-m30">

                            <DataTable
                                ref={(el) => (this.dt = el)}
                                value={organizations}
                                dataKey="id"
                                paginator
                                lazy
                                className="dataTableValuesText"
                                onSort={this.onSort}
                                onPage={this.onPage}
                                onFilter={this.onFilter}
                                rows={rows}
                                first={first}
                                totalRecords={totalRecords}
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Organizations"
                                responsiveLayout="scroll"
                            >
                                <Column header="S.No." body={(rowData, { rowIndex }) => <p>{rowIndex + 1}</p>} style={{ width: '15rem', textAlign: 'left' }} />
                                <Column
                                    header="Sub Domain"
                                    body={(rowData) =>
                                        rowData.subDomain ? (
                                            <a
                                                href={`https://${rowData.subDomain}-manage.classet.in/`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {rowData.subDomain}
                                            </a>
                                        ) : 'N/A'
                                    }
                                    style={{ width: '15rem', textAlign: 'left' }}
                                    sortable />

                                <Column field="title" header="Organization Title" style={{ width: '15rem', textAlign: 'left' }} sortable />
                                {/* <Column field="name" header="Organization Name" style={{ width: '15rem', textAlign: 'left' }} sortable /> */}
                                {/* <Column header="Org Code" body={(rowData)=> moment(rowData.orgCodeForStudentEnrollment)} style={{ width: '15rem', textAlign: 'left' }} sortable /> */}
                                {
                                    this.isColumnVisible('orgCode') && <Column sortable filter showFilterMenu={false} field="orgCode" header="Org Code" style={{ width: '15rem', textAlign: 'left' }} />

                                }
                                {
                                    this.isColumnVisible('_id') && <Column sortable filter showFilterMenu={false} field="_id" header="Org Id" style={{ width: '15rem', textAlign: 'left' }} />

                                }
                                {/* <Column
                                    header="Org Code"
                                    body={(rowData) =>
                                        rowData.orgCodeForStudentEnrollment

                                    }
                                    style={{ width: '15rem', textAlign: 'left' }}
                                    sortable
                                /> */}
                                {/* <Column
                                    header="Org Id"
                                    body={(rowData) =>
                                        rowData._id

                                    }
                                    style={{ width: '15rem', textAlign: 'left' }}
                                    sortable
                                /> */}

                                <Column header="End Date" body={(rowData) => moment(rowData.tenureEndDate).format('MMM Do YYYY, h:mm:ss a')} style={{ width: '15rem', textAlign: 'left' }} />
                                
                                <Column 
                                    field="isActive" 
                                    header="Status" 
                                    body={(rowData) => {
                                        const isActive = rowData.isActive !== undefined ? rowData.isActive : true;
                                        return (
                                            <div className="ma-status">
                                                {/* <span className="ma-status-text">{isActive ? 'Active' : 'InActive'}</span>   */}
                                                <InputSwitch 
                                                    onChange={(e) => { this.onStatusChange(e, rowData) }} 
                                                    checked={isActive} 
                                                />
                                            </div>
                                        );
                                    }} 
                                    style={{ width: '15rem', textAlign: 'left' }} 
                                />

                                <Column
                                    header="Edit"
                                    body={(rowData, { rowIndex }) => (
                                        <div className="flex ">
                                            <span data-pr-tooltip="Edit Organization" onClick={() => this.onEdit(rowData)} className={`ma-ml10 awl${rowIndex}`}>
                                                <ClassetEditIcon width={32} height={32} color={'#000000'} />
                                            </span>
                                        </div>
                                    )}
                                    style={{ width: '15rem', textAlign: 'left' }}
                                />
                                <Column header="Config" body={(rowData) => {
                                    return (<>
                                        <div className="flex ">
                                            <span data-pr-tooltip="Configuration" data-pr-position="bottom" className={`edit${rowData._id}`} onClick={() => { this.onEditConfigClick(rowData) }}>
                                                <i className="pi pi-cog" width="20" height="20"></i>
                                            </span>
                                            <Tooltip className="table-li-tooltip2" autoHide={false} target={`.edit${rowData._id}`} />
                                        </div>
                                    </>
                                    );
                                }} ></Column>
                            </DataTable>

                            {this.state.isShowConfigChange ? (
                                <OrgConfiguration
                                    editOrganization={this.state.editOrganization}
                                    onClose={() => {
                                        this.setState({
                                            isShowConfigChange: false,
                                            items: organizationItems
                                        });
                                    }}
                                    orgId={this.state.editOrganization._id}
                                />
                            ) : (<></>)}

                            <Toast ref={(el) => (this.toast = el)} position="bottom-right" />

                            {isLoading && <LoadingComponent />}
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default Authentication(withRouter(OrganizationSetupIndex));
